(() => {
  'use strict';
  // FijaDent-only presentation layer. It follows v3 and never changes native inputs, selection or submission.
  if (!['/products/fijadent', '/products/fijadent200'].includes(location.pathname) && !document.documentElement.hasAttribute('data-fd-releasit-fixture')) return;
  const addStyle = () => {
    const existing = document.getElementById('fd-releasit-v4-reference-parity');
    if (existing) {
      if (document.head.lastElementChild !== existing) document.head.appendChild(existing);
      return;
    }
    const style = document.createElement('style');
    style.id = 'fd-releasit-v4-reference-parity';
    style.textContent = `
#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected ._rsi-quantity-offers-info,
#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected ._rsi-quantity-offers-prices { transform:none!important; }
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-offer-container {
    overflow:visible!important;
  }
  /* Match the native SinLipomas flow: image | copy | prices.  Flex reserves a
     non-shrinking price column without forcing word-level wrapping in copy. */
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-offer {
    display:flex!important;
    align-items:center!important;
    /* Native image/price margins already supply the reference gaps. */
    gap:0!important;
  }
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-modal-line-item-image-container {
    flex:0 0 62px!important;
    width:62px!important;
    height:62px!important;
    min-width:62px!important;
    min-height:62px!important;
    overflow:visible!important;
  }
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-modal-line-item-image-container img {
    display:block!important;
    width:100%!important;
    height:100%!important;
    max-width:100%!important;
    max-height:100%!important;
    object-fit:contain!important;
    overflow:visible!important;
  }
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-info {
    grid-area:info!important;
    min-width:0!important;
    align-items:flex-start!important;
  }
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-title,
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-plaque,
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] .fd-releasit-detail { text-align:left!important; max-width:100%!important; min-width:0!important; overflow-wrap:normal!important; word-break:normal!important; }
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-prices {
    grid-area:prices!important;
    min-width:max-content!important;
    width:max-content!important;
    white-space:nowrap!important;
    text-align:right!important;
    align-items:flex-end!important;
  }
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-old-price,
  #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-new-price {
    min-width:max-content!important;
    white-space:nowrap!important;
    text-align:right!important;
  }
  @media (max-width:340px) {
    #_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-modal-line-item-image-container { flex-basis:54px!important; width:54px!important; height:54px!important; min-width:54px!important; min-height:54px!important; }
  }
`;
    document.head.appendChild(style);
  };
  addStyle();
  new MutationObserver(addStyle).observe(document.documentElement, { childList:true, subtree:true });
})();
